export default "__VITE_ASSET__BZaiylux__"